import React from 'react'
import cn from 'classnames'
import numeral from 'numeral'

import styles from './styles.module.scss'

const UpIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      aria-hidden="true"
      {...props}
    >
      <path d="M16 7h6v6" />
      <path d="m22 7-8.5 8.5-5-5L2 17" />
    </svg>
  )
}

const DownIcon = (props) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    aria-hidden="true"
    {...props}
  >
    <path d="M16 17h6v-6" />
    <path d="m22 17-8.5-8.5-5 5L2 7" />
  </svg>
  )
}

const MarginCell = ({value}) => {
  if (!value) {
    return '-'
  }
  return (
    <div className={cn(styles.container, {[styles.positive]: value > 0, [styles.negative]: value < 0})}>
      {
        value > 0
          ? <UpIcon />
          : value < 0
            ? <DownIcon />
            : null
      }
      { `${numeral(value || 0).format('0.[00]')}%` }
    </div>
  )
}

export default MarginCell
